// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ColumnHeightOutlinedSvg from "@ant-design/icons-svg/es/asn/ColumnHeightOutlined";
import AntdIcon from '../components/AntdIcon';

var ColumnHeightOutlined = function ColumnHeightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ColumnHeightOutlinedSvg
  }));
};

ColumnHeightOutlined.displayName = 'ColumnHeightOutlined';
export default React.forwardRef(ColumnHeightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ColumnHeightOutlined.js
// module id = 835
// module chunks = 0